export enum GoalType {
  CONVERSION = "CONVERSION",
  INFORMATIVE = "INFORMATIVE",
  SELLER = "SELLER",
}
